<mat-card class="settingsBody">
    <mat-card-header>
        <mat-card-title class="settings-heading">Notifications</mat-card-title>
    </mat-card-header>
    <mat-tab-group
        #example1
        ActiveTabIndex="tab"
        (selectedTabChange)="handleTabChange($event)"
        useAutomaticActivation
        class="settings"
    >
        <mat-tab [label]="'Notifications'" class="settings"></mat-tab>
        <mat-tab [label]="'Settings'" class="settings"></mat-tab>
    </mat-tab-group>
    <br />

    <!-- Notification History -->
    <ng-container *ngIf="tab === 0">
        <div class="grid-summary">
            <div>
                <p class="section-title">View all of your notifications.</p>
            </div>
            <button mat-stroked-button (click)="deleteChecked()">Delete All</button>
        </div>
        <div class="grid-container">
            <kendo-grid
                #grid="kendoGrid"
                [loading]="isLoadingAlertType"
                [data]="notificationGridView"
                [pageSize]="notificationState.take"
                [skip]="notificationState.skip"
                [sort]="notificationState.sort"
                [sortable]="sortable"
                [pageable]="pageable"
                [scrollable]="scrollable"
                [height]="750"
                class="lg-kendo-grid"
                (dataStateChange)="dataStateChange($event)"
            >
                <kendo-grid-column field="alertDescription" title="Description" [width]="500">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a (click)="alertClickHandler(dataItem)">
                            <i
                                class="fas"
                                [ngClass]="{
                                    'far fa-check-circle icon-check':
                                        dataItem.alertIcon == 'fa-check-circle',
                                    'far fa-info-circle icon-info':
                                        dataItem.alertIcon == 'fa-info-circle',
                                    'far fa-exclamation-circle icon-exclamation':
                                        dataItem.alertIcon == 'fa-exclamation-circle'
                                }"
                            >
                            </i>
                            {{ dataItem.alertDescription }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="alertDate" title="Alert Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.alertDate | date : 'MM/dd/yyyy hh:mm aa' }}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="isRead" title="Read">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <p-checkbox
                            [(ngModel)]="readAllCheckbox"
                            [binary]="true"
                            (onChange)="checkAllRead()"
                        />
                        <span>Read</span>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-record>
                        <p-checkbox
                            [(ngModel)]="record.isRead"
                            [binary]="true"
                            (onChange)="toggleRead(record)"
                        />
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </ng-container>

    <!-- Notification Settings -->
    <ng-container *ngIf="tab === 1">
        <p class="section-title">
            Manage which notifications you want to receive. Unless specified, all notifications will
            only be sent in Mortgage Analytics.
        </p>
        <div class="grid-container">
            <kendo-grid
                #grid="kendoGrid"
                [loading]="isLoadingAlertType"
                [data]="alertGridView"
                [pageSize]="alertTypeState.take"
                [skip]="alertTypeState.skip"
                [sort]="alertTypeState.sort"
                [sortable]="sortable"
                [pageable]="pageable"
                [scrollable]="scrollable"
                [height]="750"
                class="lg-kendo-grid"
                (dataStateChange)="dataStateChange($event)"
            >
                <kendo-grid-column field="isInactive" title="Enabled">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p-checkbox
                            class="grid-cell-checkbox"
                            [binary]="true"
                            (onChange)="toggleCheckbox(dataItem, 'isInactive')"
                        />
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="alertDescription" title="Description" [width]="450">
                </kendo-grid-column>
                <kendo-grid-column field="useEmail" title="Email">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <span>Send Email</span>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p-checkbox
                            class="grid-cell-checkbox"
                            [binary]="true"
                            (onChange)="toggleCheckbox(dataItem, 'useEmail')"
                            [disabled]="dataItem.alertTypeKey === 36 || dataItem.isInactive"
                        />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="useText" title="Text">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <span>Send Text</span>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div
                            kendoTooltip
                            *ngIf="!profileHasMobileNumber() && dataItem.alertTypeKey !== 36"
                        >
                            <a
                                title="Add mobile phone to enable text notifications"
                                href="/settings/user-profile"
                            >
                                <p-checkbox
                                    [binary]="true"
                                    (onChange)="toggleCheckbox(dataItem, 'useText')"
                                    [disabled]="!profileHasMobileNumber() || dataItem.isInactive"
                                />
                            </a>
                        </div>
                        <p-checkbox
                            *ngIf="profileHasMobileNumber() && dataItem.alertTypeKey !== 36"
                            [(ngModel)]="dataItem.useText"
                            [binary]="true"
                            (onChange)="toggleCheckbox(dataItem, 'useText')"
                            [disabled]="dataItem.isInactive"
                        />
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </ng-container>
</mat-card>
